import { render } from "./Login.vue?vue&type=template&id=cc563040&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=cc563040&scoped=true&lang=css"

import exportComponent from "C:\\inetpub\\wwwroot\\bidi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc563040"]])

export default __exports__